import { render, staticRenderFns } from "./JournalTransactionsDetail.vue?vue&type=template&id=1876e866&"
import script from "./JournalTransactionsDetail.vue?vue&type=script&lang=ts&"
export * from "./JournalTransactionsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1876e866')) {
      api.createRecord('1876e866', component.options)
    } else {
      api.reload('1876e866', component.options)
    }
    module.hot.accept("./JournalTransactionsDetail.vue?vue&type=template&id=1876e866&", function () {
      api.rerender('1876e866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/reports/JournalTransactionsDetail.vue"
export default component.exports